var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-section-group-layout",
    { attrs: { "show-divider": "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "d-flex align-items-center" },
            [
              _c("section-title", { attrs: { "title-type": "subtitle" } }, [
                _c(
                  "span",
                  { staticClass: "bold" },
                  [
                    _vm._v(
                      "\n          " + _vm._s(_vm.sectionTitle) + "\n          "
                    ),
                    _vm.hasMissingInformation
                      ? _c(
                          "span",
                          { attrs: { id: _vm.tooltipTargetId } },
                          [
                            _c("icon", {
                              staticClass: "text-danger clickable",
                              attrs: { name: "exclamation-circle" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("notification-popover", {
                      attrs: { target: _vm.tooltipTargetId },
                      scopedSlots: _vm._u([
                        {
                          key: "popoverContent",
                          fn: function () {
                            return [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.pages.pleaseReviewThisSection"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "d-flex align-items-center",
              attrs: { cols: "auto" },
            },
            [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-primary text-capitalize skip-disable-all-inputs",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("edit")
                    },
                  },
                },
                [
                  _vm.allowEdit
                    ? _c("icon", {
                        staticClass: "text-primary mr-1",
                        attrs: { name: "pencil" },
                      })
                    : _vm._e(),
                  _vm._v(
                    "\n        " + _vm._s(_vm.editButtonText) + "\n      "
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.allApplicants, function (applicant, applicantIndex) {
        return [
          _vm.showAllApplicants ||
          _vm.isApplicantVisible(applicant.id, applicantIndex)
            ? _c(
                "b-row",
                { key: applicantIndex, staticClass: "my-3" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "section-title",
                        { attrs: { "title-type": "subtitle" } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.applicantNameFromIndex(applicantIndex)
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._t("default", null, {
                        applicant: applicant,
                        applicantIndex: applicantIndex,
                      }),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }